module.exports = __webpack_public_path__ + "static/media/diego.3befcad2.jpeg";